import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Form from "react-bootstrap/Form";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import { numDifferentiationWithoutSymbol } from "../../../CommonMethhods/CovertRupees";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function IncPortfolioNew() {
  const storeToken = localStorage.getItem("ssoToken");
  const [data, setData] = useState([]);
  const [filterValue, setFilterValue] = useState("YEARLY");
  const [days, setDays] = useState();
  const [values, setValues] = useState();
  const [serverError, setServerError] = useState("");

  let clientCode = "";
  const incPortfolioChart = async (clientCode) => {
    let payloadValue = { clientCode: clientCode, Duration: filterValue };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getData = await axiosInstance.post(
        DASHBOARD_CLIENT_OVERVIEW.PortfolioOverYear_URL,
        `"${encPayload}"`,
      );
      const responseData = ApiResDecrypt(getData?.data);
      setData(responseData?.data);
    } catch (error) {
      console.log(error);
      setServerError("Something went wrong, Please try again later.");
    }
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
      incPortfolioChart(clientCode);
    }
  }, [filterValue]);

  const handleOnChange = (e) => {
    if (e.target.value) {
      setFilterValue(e.target.value);
    }
  };

  const portfolioData = (data) => {
    const temp = [];
    const Days = [];
    const holdingValue = [];
    //  if(filterValue=="MONTHLY"){
    //  data && data.map((item)=>{
    //   Days.push(item.Day)
    //   holdingValue.push(item.holdingValue)
    //  })
    //  setDays(Days)
    //  setValues(holdingValue)
    // }
    if (filterValue == "YEARLY") {
      data &&
        data.map((item) => {
          temp.push(item.holdingDays);
          holdingValue.push(item.holdingValue);
        });

      setDays(temp);
      setValues(holdingValue);
    }
  };

  useEffect(() => {
    portfolioData(data);
  }, [data]);

  // Highcharts.setOptions({
  //   lang: {
  //     thousandsSep: ','
  //   }
  // });
  const incPortfolioOverYear = {
    credits: {
      enabled: false,
    },
    chart: {
      type: "spline",
    },
    title: {
      text: null,
    },
    xAxis: {
      gridLineWidth: 0,
      categories: days ? days : [],
    },
    yAxis: {
      title: null,
      gridLineWidth: 0,
      accessibility: {
        rangeDescription: "Range: 0 to 80k.",
      },
    },
    tooltip: {
      pointFormat: `{series.name}: <b>{point.y:.2f}</b>`,
    },
    legend: {
      enabled: false,
    },

    series: [
      {
        name: "Values",
        color: "#ff86b1",
        data: values ? values : [],
      },
    ],
  };

  return (
    <>
      <div className="col-12 col-md-12">
        <div className="inc-portfolio">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.Inc_Portfolio_Years}</h2>
              <div className="filter-options">
                {/* <!-- dropdown --> */}
                {/* <div className="dropdown-filter">
                  <Form.Select
                    size="lg"
                    aria-label="Default select example"
                    onChange={handleOnChange}
                  >
                    <option value="QUARTERLY">{Constants.Quarterly}</option>
                  </Form.Select>
                </div> */}
              </div>
            </div>
            {data && data.length > 0 ? (
              <div>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={incPortfolioOverYear}
                />

                {/* </div> */}
              </div>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="no-data">{serverError}</h4>
            ) : (
              noDataFound()
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default IncPortfolioNew;
